import type { Employee } from '@/entities/employee'
import { Chip } from '@/shared/ui/chip'

/**
 * Состояние телеграма как свойство человека — без действий: привязку заводит
 * только он сам (`/employees/me/...`), администратор чужую не оформит.
 *
 * Норма молчит: в списке команды чип появляется там, где уведомления не дойдут,
 * и админ видит проблемные строки, не вычитывая одинаковые отметки у всех.
 */
export function TelegramStatus({ employee }: { employee: Employee }) {
  if (!employee.telegramLinked) return <Chip variant="soft">без телеграма</Chip>
  if (!employee.telegramReachable) return <Chip tone="accent">уведомления не доходят</Chip>
  return null
}
